import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Gallery } from '../components/Gallery';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
export function GalleryPage() {
  usePageMeta({
    title: "Before & After Detailing Gallery | Mike's Pro Detail",
    description: "See real before-and-after mobile car detailing results from Mike's Pro Detail — full details, interior deep cleans, water spot removal, engine bays and classic cars in Ventura County.",
    path: '/gallery',
    breadcrumbName: 'Gallery'
  });
  return <main data-id="element-898" data-mp="p2swgol46miq">
      <PageHeader breadcrumb="Gallery" title="Our Work" subtitle="Before & after detailing results — real vehicles from real customers in Ventura County. Tap any photo to enlarge it." data-id="element-899" data-mp="p3athnflp4rp" />
      <section className="w-full bg-black py-16 px-4" aria-label="Photo gallery" data-id="element-900" data-mp="39t0942o4oulg">
        <div className="max-w-6xl mx-auto" data-id="element-901" data-mp="3dudc84zu6joo">
          <Gallery data-id="element-902" data-mp="3dverymrsrucq" />
        </div>
      </section>
      <CallCta title={<>
            Want Results <span className="text-yellow-400" data-id="element-904" data-mp="1pk2r51lv1x1e">Like These?</span>
          </>} data-id="element-903" data-mp="3ds0p7df81j4r" />
    </main>;
}